import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AreaFilterComponent} from './area-filter/area-filter.component';
import {TranslateModule} from '../../shared/pipes/translate/translate.module';
import {GoogleMapsComponent} from './google-maps/google-maps.component';
import {OfferSliderComponent} from './offer-slider/offer-slider.component';
import {HomeComponent} from './home.component';
import {OfferPreviewComponent} from './google-maps/offer-preview/offer-preview.component';
import { HoverPreviewComponent } from './google-maps/hover-preview/hover-preview.component';
import {OfferFilterComponent} from './google-maps/offer-filter/offer-filter.component';
import {GoogleMapsModule} from '@angular/google-maps';
import {FormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    AreaFilterComponent,
    HomeComponent,
    OfferSliderComponent,
    GoogleMapsComponent,
    OfferPreviewComponent,
    HoverPreviewComponent,
    OfferFilterComponent
  ],
  imports: [CommonModule, TranslateModule, GoogleMapsModule, FormsModule, BrowserAnimationsModule],
  exports: [AreaFilterComponent]
})
export class HomeModule {
}
